import React, { useState, useEffect } from "react";
import "./Login.css";
import banner_img from "../../../images/banner-picture.png";
import login_logo from "../../../images/loginlogo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { userLoginApi } from "../../../Services/Login/LoginApi/loginApi";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CommunityOwner, HomeOwner, SuperAdmin } from "../../../Utils/Constant";
import chevronleft from "../../../images/chevronleft.svg";

function LoginComponent() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false); // Prevent multiple submissions
  const [showPassword, setShowPassword] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const userType = localStorage.getItem("user_type");

    if (accessToken && userType) {
      switch (userType) {
        // case CommunityOwner:
        //   navigate("/admin/dashboard");
        //   break;
        case SuperAdmin:
          navigate("/super-admin/super-admin-community-comp");
          break;
        // case HomeOwner:
        //   navigate("/home-owner-admin/dashboard");
        //   break;
        default:
          break;
      }
    }
  }, [navigate]);

  useEffect(() => {
    // Load saved password from local storage
    const savedPassword = localStorage.getItem("password");
    const savedEmail = localStorage.getItem("email");
    if (savedPassword && savedEmail) {
      setPassword(savedPassword);
      setEmail(savedEmail);
      setRememberPassword(true);
    }
  }, []);

  const handleRememberChange = (e) => {
    setRememberPassword(e.target.checked);
  };

  // Handler to toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  // Prevent default behavior for mouse down event
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  // Validation function
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!email) {
      formErrors.email = "Email is required.";
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      formErrors.email = "Invalid email format.";
      isValid = false;
    }

    if (!password) {
      formErrors.password = "Password is required.";
      isValid = false;
    } else if (password.length < 6) {
      formErrors.password = "Password must be at least 6 characters long.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  }; // Closing brace added here

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    if (errors.email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
    }
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    if (errors.password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent additional clicks
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true); // Lock the button

    if (rememberPassword) {
      localStorage.setItem("password", password);
      localStorage.setItem("email", email);
    } else {
      localStorage.removeItem("password");
      localStorage.removeItem("email");
    }

    try {
      const response = await dispatch(
        userLoginApi({ email, password })
      ).unwrap();

      if (response?.status === 200) {
        toast.success("Login successful! Welcome back.", { className: "toast-success" });
        localStorage.setItem("access_token", response.data.token?.access);
        localStorage.setItem("refresh-token", response.data.token?.refresh);
        localStorage.setItem("user_type", response.data?.user_type);
        localStorage.setItem("user_id", response.data?.user_id);
        localStorage.setItem("user_first_name", response.data?.first_name);
        localStorage.setItem("user_last_name", response.data?.last_name);

        // if (response.data?.user_type === CommunityOwner) {
        //   setTimeout(() => {
        //     navigate("/admin/Admin-community");
        //   }, 1000);
        // }
        if (response?.data?.user_type === SuperAdmin) {
          setTimeout(() => {
            navigate("/super-admin/super-admin-community-comp");
          }, 500);
        }
        // else if (response.data?.user_type === HomeOwner) {
        //   setTimeout(() => {
        //     navigate("/home-owner-admin/home-owner-community");
        //   }, 1000);
        // }
      }
    } catch (err) {
      toast.error("Login failed: Email and Password invalid!", {
        className: "toast-error",
      });
    } finally {
      setIsSubmitting(false); // Unlock the button
      setEmail(""); // Clear email input
      setPassword(""); // Clear password input
    }
  };

  // const [isSubmitting, setIsSubmitting] = useState(false); // Prevent multiple submissions
  // const [toastActive, setToastActive] = useState(false); // Prevent multiple toasts

  const handleSignuproute = () => {
    navigate("/signupone");
  };

  const handleBackClick = () => {
    navigate("/");
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  return (
    <>
      <section className="login-box login-page-one min-vh-100 d-flex justify-content-center align-items-center">
        <div className="container-fluid p-0 m-0">
          <div className="row m-0">
            {/* Right Column with Card */}
            <div className="col-12 d-flex justify-content-center align-items-center">
              <div className="card shadow-sm w-75 p-4 login-template-box">
                <div className="desktop-view text-center mb-4">
                  <div className="login-logoimg" onClick={() => navigate("/")}>
                    {/* Add img-fluid for responsiveness */}
                    <img
                      src={login_logo}
                      alt="login-logo"
                      className="login_logo_img img-fluid" // Make the image responsive
                    />
                  </div>
                </div>
                <div className="login-page-area">
                  <div className="login-information log-in">
                    <div className="form-login text-left">
                      <div className="mb-4">
                        <InputLabel htmlFor="standard-adornment-email">
                          Email <span>*</span>
                        </InputLabel>
                        <Input
                          className="email-input-box"
                          id="standard-adornment-email"
                          type="email"
                          placeholder="Email"
                          onChange={handleEmailChange}
                          value={email}
                          onKeyDown={handleKeyDown}
                        />
                        {errors.email && (
                          <p className="text-danger">{errors.email}</p>
                        )}
                      </div>
                      <div className="mb-4">
                        <InputLabel htmlFor="standard-adornment-password">
                          Password <span>*</span>
                        </InputLabel>
                        <Input
                          className="password-input-box"
                          id="standard-adornment-password"
                          placeholder="Password"
                          type={showPassword ? "text" : "password"}
                          onChange={handlePasswordChange}
                          value={password}
                          onKeyDown={handleKeyDown}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label={
                                  showPassword
                                    ? "hide the password"
                                    : "display the password"
                                }
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        {errors.password && (
                          <p className="text-danger">{errors.password}</p>
                        )}
                      </div>

                      <div className="btn-orange">
                        <Button onClick={handleSubmit} disabled={isSubmitting}>
                          {isSubmitting ? "Submitting..." : "Sign In"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default LoginComponent;
